import {
  reactQueryDelete,
  reactQueryGet,
  reactQueryPatch,
  reactQueryPost,
  reactQueryPut,
} from "../helpers/backendRequestHelpers";
import { internalApi } from "../helpers/urlHelpers";

export interface IdArgs {
  id: number;
}

export interface IdResponseData {
  id: number;
}

export interface IdParams {
  id: number;
  params?: Record<string, unknown>;
}

export interface ListBroadcastsParams {
  params?: {
    status?: string;
    page?: number;
    per_page?: number;
    query?: string;
  };
}

const list = ({ params = {} }: ListBroadcastsParams) =>
  reactQueryGet(internalApi.broadcasts.list({ params }));

export interface CreateBroadcastParams {
  broadcast_content_attributes?: {
    subject: string;
    preview_text: string;
    email_content?: string;
    visual_email_builder_content?: string;
  };
  internal_name: string;
  preview_text?: string;
  subject?: string;
}

const create = (params: CreateBroadcastParams) =>
  reactQueryPost<IdResponseData>(internalApi.broadcasts.create(), params);

const show = ({ id }: IdArgs) =>
  reactQueryGet(internalApi.broadcasts.show({ id }));

export interface UpdateParams {
  body: any;
  id: number;
}

const update = ({ id, body }: UpdateParams) =>
  reactQueryPut<IdResponseData, object>(
    internalApi.broadcasts.show({ id }),
    body,
  );

const sendNow = ({ id }: IdArgs) =>
  reactQueryPatch(internalApi.broadcasts.sendNow({ id }));

const duplicate = ({ id }: IdArgs) =>
  reactQueryPut<IdResponseData, object>(
    internalApi.broadcasts.duplicate({ id }),
  );

const recipientList = ({ id, params = {} }: IdParams) =>
  reactQueryGet(internalApi.broadcasts.recipientList({ id, params }));

const report = ({ id }: IdArgs) =>
  reactQueryGet(internalApi.broadcasts.report({ id }));

const recipients = ({ id, params = {} }: IdParams) =>
  reactQueryGet(internalApi.broadcasts.recipients({ id, params }));

const cancelSchedule = ({ id }: IdArgs) =>
  reactQueryPatch<IdArgs, object>(
    internalApi.broadcasts.cancelSchedule({ id }),
  );

export interface RenameBroadcastBody {
  internal_name: string;
}

interface RenameBroadcastParams {
  body: RenameBroadcastBody;
  id: number;
}

const rename = ({ id, body }: RenameBroadcastParams) =>
  reactQueryPatch<IdResponseData, RenameBroadcastBody>(
    internalApi.broadcasts.rename({ id }),
    body,
  );

const sendTestEmail = ({ id }: IdArgs) =>
  reactQueryPatch(internalApi.broadcasts.sendTestEmail({ id }));

const deleteBroadcast = ({ id }: IdArgs) =>
  reactQueryDelete(internalApi.broadcasts.deleteBroadcast({ id }));

interface UpdateTemplateParams {
  body: { marketing_email_template_id: number };
  id: number;
}

const updateTemplate = ({ id, body }: UpdateTemplateParams) =>
  reactQueryPatch(internalApi.broadcasts.updateTemplate({ id }), body);

type SourceContentType = "Post" | "InvitationLink" | "Event";

const createFromSource = (body: {
  source_content_id: number;
  source_content_type: SourceContentType;
}) => reactQueryPost(internalApi.broadcasts.createFromSource(), body);

const resetContent = ({ id }: IdArgs) =>
  reactQueryPatch(internalApi.broadcasts.resetContent({ id }));

const exportRecipients = ({ id, params = {} }: IdParams) =>
  reactQueryGet(internalApi.broadcasts.exportRecipients({ id, params }));

export const broadcastsApi = {
  list,
  create,
  show,
  update,
  sendNow,
  duplicate,
  recipientList,
  report,
  recipients,
  cancelSchedule,
  rename,
  sendTestEmail,
  deleteBroadcast,
  updateTemplate,
  createFromSource,
  resetContent,
  exportRecipients,
};
